import { api } from "../api";
export const createPdc = async (
    powerDistributionCompanyName,
    stateId,
    hasProcessing,
    hasDifferentArtPrice,
    artPrice,
    defaultEngineerId
  ) => {
    let url = `/pdc`;
  
    return await api.post(url, {
      powerDistributionCompanyName,
      stateId,
      hasProcessing,
      hasDifferentArtPrice,
      artPrice,
      defaultEngineerId
    });
  };
  
  export const updatePdc = async (
    powerDistributionCompanyId,
    powerDistributionCompanyName,
    stateId,
    hasProcessing,
    hasDifferentArtPrice,
    artPrice,
    defaultEngineerId
  ) => {
    let url = `/pdc/${powerDistributionCompanyId}`;
  
    return await api.put(url, {
      powerDistributionCompanyName,
      stateId,
      hasProcessing,
      hasDifferentArtPrice,
      artPrice,
      defaultEngineerId
    });
  };
  
  export const deletePdc = async (
    powerDistributionCompanyId
  ) => {
    let url = `/pdc/${powerDistributionCompanyId}`;
  
    return await api.delete(url);
  };